'use client';

import { useTranslations } from 'next-intl';

// Translates static English labels (nav items, tab names, role names, statuses)
// that live in module-level arrays where hooks can't be used. The English label
// is turned into a camelCase key under the "Labels" namespace; labels without a
// translation fall back to the original text. ALL-CAPS labels are looked up in
// their normal case and upper-cased again.
export function labelKey(label: string) {
  return label
    .replace(/[^A-Za-z0-9]+/g, ' ')
    .trim()
    .split(' ')
    .map((word, i) => (i ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word.toLowerCase()))
    .join('');
}

export function useLabel() {
  const t = useTranslations('Labels');
  return (label: string) => {
    const isUpper = label.length > 3 && label === label.toUpperCase();
    const key = labelKey(label);
    if (!t.has(key)) return label;
    const text = t(key);
    return isUpper ? text.toUpperCase() : text;
  };
}
